import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStorage } from './appStorage.service';
import { ENDPOINTS } from '../constants/app-values';

@Injectable({
  providedIn: 'root'
})
export class ApiEmpresasService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  getEmpresas() {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token,
      'Content-type': 'application/json'
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/empresa/todas`, { headers: headers })
      .toPromise();
  }

  getEmpresasPublico() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/publico/empresas/`, { headers: headers })
      .toPromise();
  }

  getEmpresasUsuarioEmpresa() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/usuario/empresas/`, { headers: headers })
      .toPromise();
  }

  guardarNombreCorto(idEmpresa, sigla) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = { nombreCorto: sigla };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/empresa/${idEmpresa}/nombrecorto`, body, {
        headers: headers
      })
      .toPromise();
  }
}
